import { languages } from '@config';

export default function useLanguages() {
  return languages.map((l) => l.lang);
}
